import React from 'react';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';
import { AppRouteProps } from '~/routes';

export default function DistrictRoutes(): readonly AppRouteProps[] {
  const routes: AppRouteProps[] = [
    {path: '/district', component: Index, isProtected: true, permissions: ['district_index']},
    {path: '/district/create', component: Create, isProtected: true, permissions: ['district_create']},
    {path: '/district/edit/:id', component: Edit, isProtected: true, permissions: ['district_edit']},

  ];

  return routes;
}
